"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverLevelDisplay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var services_1 = require("@falcon/services");
var React = require("react");
var Tree_1 = require("./Tree");
var CoverLevelDisplay = /** @class */ (function (_super) {
    __extends(CoverLevelDisplay, _super);
    function CoverLevelDisplay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    CoverLevelDisplay.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Home cover level: ", this.getHomeCoverTier(this.props.coverLevel)] }) });
    };
    CoverLevelDisplay.prototype.getHomeCoverTier = function (coverTierEnumName) {
        switch (coverTierEnumName) {
            case services_1.HomeCoverLevelEnum.BUILDINGS_CONTENTS: {
                return "Buildings and Contents";
            }
            case services_1.HomeCoverLevelEnum.BUILDINGS: {
                return "Buildings Only";
            }
            case services_1.HomeCoverLevelEnum.CONTENTS: {
                return "Contents Only";
            }
            default: {
                return "";
            }
        }
    };
    return CoverLevelDisplay;
}(React.Component));
exports.CoverLevelDisplay = CoverLevelDisplay;
//# sourceMappingURL=CoverLevelDisplay.js.map